import { type ServerError } from 'constants/server-error';

import { type StartupErrorViewState } from './interfaces';

interface WithStartupErrorViewState {
  views: {
    startupError: StartupErrorViewState;
  };
}

export function getIsUnexpectedStartupErrorVisible(state: WithStartupErrorViewState): boolean {
  return state.views.startupError.isUnexpectedErrorVisible;
}

export function getSignInError(state: WithStartupErrorViewState): ServerError | undefined {
  return state.views.startupError.signInError;
}

export function getIsNetworkIssuesVisible(state: WithStartupErrorViewState): boolean {
  return state.views.startupError.isNetworkIssuesVisible;
}
